// React
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

// Components
import BPeriod from 'shop-components/components/MiniCart/styles/Period'
import B from 'ui/elements/B'

// Hooks
import { useTranslation } from 'shared/utils/useTranslation'
import { useOrm } from 'shared/utils/useOrm'

// Utils
import { formatDeliveryAddress } from 'shared/utils/deliveryAddressUtils'

export const FulfillmentDetails = ({ cart, locations, hasLocations }) => {
  const country = useOrm('countries', (collection) => {
    if (cart?.data?.fulfillment_type === 'pickup') return null

    return collection.getById(cart?.data?.delivery_address?.country_id)
  })

  const { t } = useTranslation('user')

  const formattedDeliveryAddress = formatDeliveryAddress(cart?.data?.delivery_address, country)

  const renderPickupDetails = () => (
    <Fragment>
      {t('user.deliveries.pickup')}
      {hasLocations && (
        <Fragment>: {cart?.start_location_id ? locations.getById(cart.start_location_id)?.name : null}</Fragment>
      )}
    </Fragment>
  )

  const renderDeliveryDetails = () => (
    <Fragment>
      {t('user.deliveries.delivery')}
      {!!formattedDeliveryAddress && `: ${formattedDeliveryAddress}`}
    </Fragment>
  )

  return (
    <BPeriod.Detail>
      <B modifiers="line-clamp-1">{cart?.data?.fulfillment_type === 'delivery' ? renderDeliveryDetails() : renderPickupDetails()}</B>
    </BPeriod.Detail>
  )
}

FulfillmentDetails.propTypes = {
  cart: PropTypes.object,
  locations: PropTypes.object,
  hasLocations: PropTypes.bool
}
